import type { Form } from '../../../common/types/form';
import type { Documentation } from '../../../common/types/documentation';

const socialMediaForm: Form<Documentation> = {
  key: 'socialMedia',
  title: 'Social Media',
  fields: [
    {
      key: 'date',
      label: 'Datum',
      fieldTypes: 'date',
      validateIsNotEmpty: true,
    },
    {
      key: 'socialMedia',
      label: 'Social Media',
      fieldTypes: 'select',
      options: [
        { value: 'instragram', label: 'Instagram' },
        { value: 'facebook', label: 'Facebook' },
      ],
    },
    {
      key: 'follower',
      label: 'Follower',
      fieldTypes: 'number',
    },
    {
      key: 'posts',
      label: 'Posts',
      fieldTypes: 'number',
    },
  ],
};

export default socialMediaForm;
